import fetchAPI from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { modifyMetricData } from '../../utils/getMetrics';
import { generateMongoLikeId } from '../../utils/uuidGenerator';
import store from '../store';
import { enqueueSnackbar } from './snackbar';
import { listWells } from './wells';
import * as ENVIRONMENT from '../../shared/config/config';
import { UNIT_SYSTEM } from '../../shared/config/hydraulics_constants';
import { VERSION } from '../../shared/config/version';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}
export const listDrillString = (wellId, closeDialog) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: wellId
    }
  };
  return fetchAPI
    .post('wells/entity/drillString/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: drillStringData, units } = data;
      const modifiedDrillStringData = modifyMetricData(drillStringData, units, currentUnit);
      dispatch({
        type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_SUCCESS,
        payload: {
          ...data,
          data: modifiedDrillStringData,
          paginatedElements: modifiedDrillStringData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      if (error?.status === 403) {
        closeDialog?.();
      }
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
export const addNewDrillStringRow = () => (dispatch) => {
  const { wellsDrillString } = store.getState();
  const newDrillString = [...wellsDrillString.data];
  const existUnit = { ...wellsDrillString.units };
  const nextId = newDrillString.length - 1;
  const newRow = {
    name: '',
    MD: '',
    drillstring_details: [],
    bit_details: {},
    lastUpdate: new Date(),
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true
  };
  newDrillString.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_SUCCESS,
    payload: {
      data: newDrillString,
      units: existUnit,
      paginatedElements: newDrillString.length,
    },
  });
};

export const copyDrillStringRow = (row) => (dispatch) => {
  const { wellsDrillString } = store.getState();
  const newDrillString = [...wellsDrillString.data];
  const existUnit = { ...wellsDrillString.units };
  const newRow = {
    name: '',
    MD: '',
    drillstring_details: row?.drillstring_details?.map(item => ({
      ...item,
      _id: generateMongoLikeId(),
    })) || [],
    bit_details: row?.bit_details,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true,
    permissionId: row?.permissionId || undefined
  };
  newDrillString.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_SUCCESS,
    payload: {
      data: newDrillString,
      units: existUnit,
      paginatedElements: newDrillString.length,
    },
  });
};

export const createDrillString = (body, wellId, details) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  delete body._id;
  delete body?.isNewRow;
  delete body?.isDirty;
  delete body?.lastUpdate;
  delete body?.grid_id;
  const input = {
    input: {
      ...body,
      wellsInfoId: wellId,
    }
  };
  return fetchAPI
    .post('wells/entity/drillString/create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      if (details) {
        dispatch({
          type: REDUX_ACTIONS.WELLS_DRILL_STRING_SET_ID,
          payload: {
            data: data.data._id,
          },
        });
      }
      dispatch(
        enqueueSnackbar(
          'Drillstring Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellId));
    });
};
export const updateDrillString = (body) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  delete body?.isNewRow;
  delete body?.isDirty;
  const input = {
    query: {
      _id: body?._id
    },
    input: {
      ...body
    }
  };
  return fetchAPI
    .put('wells/entity/drillString', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drillstring Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(body?.wellsInfoId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(body?.wellsInfoId));
    });
};
export const deleteDrillStringRow = (deleteDrillStringId, wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  const body = {
    query: {
      wellsInfoId: wellId,
      _id: deleteDrillStringId
    }
  };
  return fetchAPI
    .deleteAction('wells/entity/drillString', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drillstring deleted successfully',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellId));
    });
};
export const updateDrillStringDetails = (data) => (dispatch) => {
  const { wellsDrillString } = store.getState();
  const currentDrillString = [...wellsDrillString.data];
  const index = currentDrillString.findIndex(drillstring => drillstring._id === data._id);
  currentDrillString[index] = data;

  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_SUCCESS,
    payload: {
      data: currentDrillString,
      units: wellsDrillString?.units,
      paginatedElements: currentDrillString.length,
    },
  });
};
export const importDrillStringDetails = (data) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING,
  });
  const drillStringList = data.sort((a, b) => a.md - b.md).map((value, index) => {
    return {
      ...value,
      id: generateRandom(),
      grid_id: index,
      _id: index
    };
  });
  setTimeout(() => {
    dispatch({
      type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_SUCCESS,
      payload: {
        data: drillStringList,
        paginatedElements: drillStringList.length,
      }
    });
    dispatch(
      enqueueSnackbar(
        'CSV file imported Successfully.',
        'success',
        new Date().getTime() + Math.random()
      ));
  }, 2000);
};

export const createDrillStringDetailsProperty = (drillId, body, wellsInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  delete body._id;
  const input = {
    query: {
      drillId,
      wellsInfoId
    },
    input: body
  };
  return fetchAPI
    .post('wells/entity/drillString/properties/create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill String Details Property Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listWells());
      dispatch(listDrillString(wellsInfoId));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
    });
};
export const updateDrillStringDetailsProperty = (drillId, _id, body, wellsInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  const input = {
    query: {
      drillId,
      wellsInfoId,
      _id
    },
    input: body
  };
  return fetchAPI
    .put('wells/entity/drillString/properties', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill String Details Property Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listWells());
      dispatch(listDrillString(wellsInfoId));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
    });
};
export const deleteDrillStringDetailsProperty = (drillId, _id, wellsInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  const input = {
    query: {
      drillId,
      wellsInfoId,
      _id
    },
  };
  return fetchAPI
    .deleteAction('wells/entity/drillString/properties', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill String Details Property Deleted Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
    });
};

export const createDrillStringBitProperty = (drillId, body, wellsInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  const input = {
    query: {
      drillId,
      wellsInfoId
    },
    input: body
  };
  return fetchAPI
    .post('wells/entity/drillBit/properties/create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill Bit Property Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
    });
};
export const deleteDrillBitDetailsProperty = (drillId, wellsInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  const input = {
    query: {
      drillId,
      wellsInfoId
    },
  };
  return fetchAPI
    .deleteAction('wells/entity/drillBit/properties', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill Bit Property Deleted Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
    });
};
export const updateDrillStringBitDetailsProperty = (drillId, body, wellsInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  const input = {
    query: {
      drillId,
      wellsInfoId
    },
    input: body
  };
  return fetchAPI
    .put('wells/entity/drillBit/properties', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill Bit Details Property Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
    });
};
export const updateDrillStrigPosition = (drillId, _id, body, wellsInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_LIST_LOADING
  });
  const input = {
    query: {
      drillId,
      wellsInfoId,
      _id
    },
    input: body
  };
  return fetchAPI
    .put('wells/entity/drillString/properties/switchPosition', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill String Details Position Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillString(wellsInfoId));
    });
};

export const importDrillStringJsonFile = (file, drillStringId, wellsInfoId, setIsLoading, handleUploadSuccess) => async (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_STRING_DETAILS_LIST_LOADING,
  });
  const formData = new FormData();
  const { currentUser } = store.getState();
  const ipDetails = {
    ip: currentUser?.ip,
  };
  const BASE_URL = ENVIRONMENT.API_URL;
  formData.append('file', file);
  const payload = {
    query: {
      wellsInfoId,
      drillId: drillStringId,
    },
    user: {
      type: currentUser.type,
      companyId: currentUser.companyId,
      userId: currentUser.userId,
      unitSystem: currentUser?.preferences?.unitSystem || UNIT_SYSTEM.US,
      ...(ipDetails?.ip && { ...ipDetails }),
      version: VERSION
    },
  };
  formData.append('payload', JSON.stringify(payload));
  setIsLoading(true);
  try {
    const response = await fetch(`${BASE_URL}wells/entity/drillString/importSingle`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });
    if (response.status !== 200) {
      const errorData = await response.json();
      const errorMessage = errorData.message;
      throw new Error(errorMessage);
    }
    setIsLoading(false);
    handleUploadSuccess();
    await dispatch(listDrillString(wellsInfoId));
  } catch (error) {
    let errorMessage = '';

    if (typeof error === 'string') {
      errorMessage = error;
    } else if (error instanceof Error) {
      errorMessage = error.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = 'An unknown error occurred';
    }

    const extractedMessage = errorMessage.split(' at importDrillStringDataFromCSV')[0].trim();

    dispatch(
      enqueueSnackbar(
        extractedMessage,
        'error',
        new Date().getTime() + Math.random()
      )
    );
    setIsLoading(false);
    dispatch(listDrillString(wellsInfoId));
  }
};
